import React from 'react';

function MoveInbox(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M18.875 3C19.8609 3 20.6696 3.76174 20.7444 4.72852L20.75 4.875V12.375C20.75 12.7202 20.4702 13 20.125 13C19.8112 13 19.5514 12.7687 19.5068 12.4674L19.5 12.375V5.08607L13.4803 9.68601C12.3372 10.7282 10.6135 10.7717 9.45859 9.84683L9.31127 9.72072L3.25 5.08751V14.875C3.25 15.1885 3.48155 15.4485 3.78272 15.4932L3.875 15.5H8.875C9.22018 15.5 9.5 15.7798 9.5 16.125C9.5 16.4388 9.26874 16.6986 8.96736 16.7432L8.875 16.75H3.875C2.88912 16.75 2.08043 15.9883 2.00564 15.0215L2 14.875V4.875C2 3.88912 2.76174 3.08043 3.72852 3.00564L3.875 3H18.875ZM4.21214 4.25H18.5359L12.6795 8.72766L12.5426 8.84179C11.795 9.41252 10.7854 9.3764 10.1119 8.76233L4.21214 4.25Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M16 12.5L11 16.25C10.6667 16.5 10.6667 17 11 17.25L16 21L16.0791 21.051C16.4832 21.2714 17 20.9828 17 20.5V19.25H20.125C21.1602 19.25 22 18.4102 22 17.375V16.125L21.9944 15.9785C21.9196 15.0117 21.1109 14.25 20.125 14.25H17V13C17 12.485 16.412 12.191 16 12.5ZM12.417 16.75L15.75 14.25V14.875C15.75 15.2202 16.0298 15.5 16.375 15.5H20.125C20.4698 15.5 20.75 15.7802 20.75 16.125V17.375C20.75 17.7198 20.4698 18 20.125 18H16.375L16.2826 18.0068C15.9813 18.0514 15.75 18.3112 15.75 18.625V19.25L12.417 16.75Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default MoveInbox;
